<template>
  <div class="me_box">
    <div class="heads">
        <img
          src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fkano.guahao.cn%2F23r2858945.jpg%3Ftimestamp%3D1499675717081&refer=http%3A%2F%2Fkano.guahao.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1665023000&t=d4e85814dd371eb693345b2076496c66"
        />
      </div>
    <div class="patient_box">
      <!-- <div class="patient"> -->
        <span>{{ patientInfo.Name }}</span>
        <span>{{ GetSexText(patientInfo.Sex) }}</span>
        <span>{{ GetAgeText(patientInfo.Birthday) }}</span>
      <!-- </div> -->
      
    </div>
    <div class="goods-card">
      <h2 class="goods_title">我的订单</h2>
      <van-row>
        <van-col span="8" v-for="(item, index) in ['全部']" :key="index" @click="$router.push('/MyOrder')">
          <div style="padding: 5px; text-align: center">
            <van-icon name="cart-o" size="35" />
          </div>

          <p>{{ item }}</p>
        </van-col>
      </van-row>
    </div>
    <div class="goods-card">
      <h2 class="goods_title">开票信息</h2>
      <van-row>
        <van-col
          span="8"
          v-for="(item, index) in billingInfo"
          :key="index"
          @click="$router.push('/BillingInfo')"
        >
          <div style="padding: 5px; text-align: center">
            <van-icon :name="item.icon" size="35" />
          </div>
          <p>{{ item.title }}</p>
        </van-col>
      </van-row>
    </div>
    <div style="position: absolute;bottom: 20px;left: 10px;right: 10px;margin: auto;">
    <van-button  color="#40a5ff" plain block @click="loginOut">退出登录</van-button>

    </div>
  </div>
</template>

<script>
import { GetCloudImagePatientInfo } from '@/utils/cacheUtils'
import { GetAgeText, GetSexText } from '@/utils/common'
import { removeToken, removeLoginName, removeNextTimeRouter } from '@/utils/auth'
export default {
  name: 'Me',
  data() {
    return {
      patientInfo: {},
      billingInfo: [
        {
          title: '已开',
          icon: 'passed',
        },
        {
          title: '未开',
          icon: 'todo-list-o',
        },
        {
          title: '全部',
          icon: 'completed',
        },
      ],
    }
  },
  created() {
    this.patientInfo = GetCloudImagePatientInfo()
  },
  methods: {
    GetAgeText,
    GetSexText,
    loginOut() {
      this.$router.replace('/login')
      localStorage.clear()
      removeToken()
      removeLoginName()
      removeNextTimeRouter()
    },
  },
}
</script>

<style  scoped>
.me_box {
  height: 100%;
}
.patient_box {
  height: 60px;
  font-size: 18px;
  color: white;
  display: flex;
  justify-content: flex-start;
  box-shadow: 0 0 14px rgba(186, 195, 209, 0.5);
  border-radius: 8px;
  padding: 10px;
  background-image: url(../../../assets/main_top.png);
  background-size: 100% 80%;
  background-repeat: no-repeat;
  background-color: white;
  position: relative;
}
.patient_box span {
  margin-left: 15px;
}
.heads {
  width: 70px;
  height: 70px;
  border: 1px solid green;
  border-radius: 50%;
  overflow: hidden;
  position: absolute;
  right: 20px;
  top: 10px;
}
img {
  height: 100%;
}
.goods-card {
  margin: 15px 0;
  background-color: white;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 0 14px rgba(186, 195, 209, 0.5);
}
.goods_title {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 5px;
}
.goods_content {
  text-align: center;
}
.goods_content div:nth-child(1) {
  height: 100px;
  padding: 5px;
}
.goods-card p {
  text-align: center;
  font-size: 12px;
}
</style>